import Blue from "~/core";

new Blue({
	name: 'Filters Tag Clicks',
	selector: ".filters",
	setup(container) {
		let tags = [...container.querySelectorAll(".filters__tag")];
		let select = container.querySelector("select.filters__select");
		tags.forEach(t => {
			this.$addEvents(t, "click.prevent", e => {
				container.querySelector(".filters__tag.is-active")
					.classList.remove("is-active");
				t.classList.add("is-active");
			});
		});
		this.$addEvents(container, "click", e => {
			if (!e.target.closest("select.filters__select")) {
				select.blur();
			}
		});
	}
});